import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { Button, Input, message, Select, Radio, Checkbox, Card } from 'antd';
import { axiosCms } from 'Axios.js';
import styles from './PromoPage.module.css';
import * as Page from 'HOC/Layout/PageContainer';
import WithError from 'HOC/Error/WithError';
import PromosTable from 'components/Promo/PromosTable';
import CreatePromoModal from 'components/Promo/CreatePromoModal';
import EditPromoModal from 'components/Promo/EditPromoModal';
import PromoImageModal from 'components/Promo/PromoImageModal';
import PromoNotifModal from 'components/Promo/PromoNotifModal';

import {
  createPromo,
  deletePromo,
  deletePromoduct,
  fetchAllProducts,
  fetchPromo,
  fetchPromos,
  notifyPromo,
  patchPromo,
  updateHighlightedPromos,
  fetchProductTypes,
  fetchProductsByTypes,
} from 'store/actions/index';
import { PRODUCT_TYPES } from 'store/reducers/product';

const { Container, Title } = Page;

const DEFAULT_FILTER = {
  productTypes: [],
};

class PromoPage extends Component {
  getHighlightedItemsFromPromos = promos => {
    return (promos || [])
      .filter(v => v.highlighted)
      .sort((a, b) => a.highlight_order - b.highlight_order)
      .map(v => {
        return v.id;
      });
  };
  state = {
    showCreateModal: false,
    showEditModal: false,
    editPromo: {},
    showImageModal: false,
    listType: 'all',
    searchProduct: '',
    debouncedSearchProduct: '',
    highlightedItems: this.getHighlightedItemsFromPromos(this.props.promos),
    previousFilter: DEFAULT_FILTER,
    filter: DEFAULT_FILTER,
    selectedHighlightToReOrder: null,
  };

  tick = createRef(null);

  previousHighlightedItems = createRef(null);

  componentDidMount = () => {
    const { fetchPromos, fetchAllProducts, products, fetchProductTypes } = this.props;

    fetchPromos(this.state.listType);

    if (products.length === 0) {
      fetchAllProducts();
    }

    fetchProductTypes();
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.promos !== this.props.promos) {
      this.setState({
        highlightedItems: this.getHighlightedItemsFromPromos(this.props.promos),
      });
    }
  }

  handleOnClickIncreaseOrderOfHighlighted = id => {
    const { highlightedItems } = this.state;
    if (!this.previousHighlightedItems.current) {
      this.previousHighlightedItems.current = highlightedItems;
    }

    const index = highlightedItems.indexOf(id);
    const newHighlightedItems = [...highlightedItems];
    newHighlightedItems.splice(index, 1);
    newHighlightedItems.splice(index - 1, 0, id);
    this.setState({ highlightedItems: newHighlightedItems });
  };

  handleOnClickDecreaseOrderOfHighlighted = id => {
    const { highlightedItems } = this.state;
    if (!this.previousHighlightedItems.current) {
      this.previousHighlightedItems.current = highlightedItems;
    }

    const index = highlightedItems.indexOf(id);
    const newHighlightedItems = [...highlightedItems];
    newHighlightedItems.splice(index, 1);
    newHighlightedItems.splice(index + 1, 0, id);
    this.setState({ highlightedItems: newHighlightedItems });
  };

  componentWillUnmount = () => {
    if (this.tick.current) {
      clearTimeout(this.tick.current);
    }
  };

  toggleCreateModal = () => {
    this.setState(prevState => ({
      ...prevState,
      showCreateModal: !this.state.showCreateModal,
    }));
  };

  saveEditFormRef = form => {
    this.editForm = form;
  };

  saveCreateFormRef = form => {
    this.createForm = form;
  };

  onChangeSearchProductInput = e => {
    const value = e.target.value;
    this.setState({ searchProduct: value });
    if (this.tick.current) {
      clearTimeout(this.tick.current);
    }
    this.tick.current = setTimeout(() => {
      this.setState({ debouncedSearchProduct: value });
    }, 500);
  };

  onCreateSubmit = e => {
    e.preventDefault();

    const { validateFields } = this.createForm;
    const { createPromo, fetchPromos } = this.props;

    validateFields((err, values) => {
      if (!err) {
        const { date_range } = values;
        if (Array.isArray(date_range)) {
          var data = {
            ...values,
            start_date: date_range[0],
            end_date: date_range[1],
          };
        } else {
          data = { ...values };
        }

        delete data.date_range;

        createPromo(data)
          .then(() => {
            fetchPromos();
            this.toggleCreateModal();
            setTimeout(() => {
              this.createForm.resetFields();
            }, 100);
          })
          .then(() => {
            message.success('Create successful', 1);
          })
          .catch(console.error);
      } else {
        console.error(err);
      }
    });
  };

  handleAddProducts = id => {
    this.props.history.push('/products');
    message.info("Choose products then click 'Preview Cart' to add to a promotion");
  };

  handleChangeSelectType = value => {
    this.setState({ listType: value });
  };

  handleOnClickClearHighlight = id => {
    const { highlightedItems } = this.state;
    const index = highlightedItems.indexOf(id);
    const newHighlightedItems = [...highlightedItems];
    newHighlightedItems.splice(index, 1);
    this.setState({
      highlightedItems: newHighlightedItems,
      selectedHighlightToReOrder:
        id === this.state.selectedHighlightToReOrder ? null : this.state.selectedHighlightToReOrder,
    });
  };

  handleOnChangeHighlightedItems = (id, checked) => {
    const { highlightedItems } = this.state;
    if (checked) {
      if (highlightedItems.length >= 4) {
        message.error('cannot highlight more than 4 items');
        return;
      }
      this.setState({
        highlightedItems: highlightedItems.includes(id) ? highlightedItems : [...highlightedItems, id],
      });
    } else {
      this.setState({
        highlightedItems: highlightedItems.filter(item => item !== id),
      });
    }
  };

  handleOnClickApplyHighlight = () => {
    const { highlightedItems } = this.state;
    const { updateHighlightedPromos } = this.props;
    updateHighlightedPromos(highlightedItems, () => {
      message.success('Updated list highlighted promotions / news');
    });
    this.setState({ selectedHighlightToReOrder: null });
  };

  handleOnChangeSelectedHighlightToReOrder = e => {
    this.setState({ selectedHighlightToReOrder: e.target.value });
  };

  handleOnClickCancelReOrderHighlight = () => {
    if (this.previousHighlightedItems.current) {
      this.setState({
        highlightedItems: this.previousHighlightedItems.current,
        selectedHighlightToReOrder: null,
      });
    }
  };

  renderEditHighlightPromos = () => {
    const { promos = [] } = this.props;
    return (
      <Card
        title={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            Re-order Highlighted News
            <React.Fragment>
              <Button
                onClick={() => this.handleOnClickIncreaseOrderOfHighlighted(this.state.selectedHighlightToReOrder)}
                style={{ margin: '0 0.5rem' }}
                disabled={
                  this.state.selectedHighlightToReOrder === null ||
                  (this.state.highlightedItems || []).indexOf(this.state.selectedHighlightToReOrder) === 0
                }
              >
                Move Up
              </Button>
              <Button
                onClick={() => this.handleOnClickDecreaseOrderOfHighlighted(this.state.selectedHighlightToReOrder)}
                style={{ margin: '0 0.5rem' }}
                disabled={
                  this.state.selectedHighlightToReOrder === null ||
                  (this.state.highlightedItems || []).indexOf(this.state.selectedHighlightToReOrder) ===
                    this.state.highlightedItems.length - 1
                }
              >
                Move Down
              </Button>
            </React.Fragment>
            <Button type="primary" onClick={this.handleOnClickApplyHighlight} style={{ margin: '0 0.5rem' }}>
              Apply
            </Button>
            <Button style={{ margin: '0 0.5rem' }} onClick={this.handleOnClickCancelReOrderHighlight}>
              Cancel
            </Button>
          </div>
        }
        style={{ marginTop: '1rem' }}
      >
        <Radio.Group
          onChange={this.handleOnChangeSelectedHighlightToReOrder}
          value={this.state.selectedHighlightToReOrder}
        >
          {this.state.highlightedItems.map((v, index) => {
            const promo = promos.find(promo => promo.id === v);

            return (
              <div key={v} className={styles.HighlightedItem}>
                <Radio value={v}>#{index + 1}</Radio>
                <div className={styles.HighlightedItemTitle}>
                  <p className={styles.HighlightedItemTitleText}>{promo.title}</p>
                </div>
                {this.state.selectedHighlightToReOrder === v && (
                  <Button
                    type="danger"
                    icon={'close'}
                    style={{ margin: '0 0.5rem' }}
                    onClick={() => this.handleOnClickClearHighlight(v)}
                  ></Button>
                )}
              </div>
            );
          })}
        </Radio.Group>
      </Card>
    );
  };

  handleOnClickApplyFilter = () => {
    const productTypes = this.state.filter.productTypes;

    this.setState({ previousFilter: this.state.filter });

    const { fetchProductsByTypes } = this.props;
    fetchProductsByTypes(productTypes);
  };

  handleOnClickFilterProductTypeItem = id => {
    const { productTypes } = this.state.filter;
    const index = productTypes.indexOf(id);
    const newProductTypes = [...productTypes];
    if (index === -1) {
      newProductTypes.push(id);
    } else {
      newProductTypes.splice(index, 1);
    }

    this.setState({ filter: { ...this.state.filter, productTypes: newProductTypes } });
  };

  handleOnClickClearFilter = () => {
    this.setState({ filter: DEFAULT_FILTER });
  };

  isAbleToHideItemHasNoProduct = () => {
    const { previousFilter, debouncedSearchProduct } = this.state;
    if (previousFilter.productTypes.length > 0 && previousFilter.productTypes.length < PRODUCT_TYPES.length) {
      return true;
    }

    if (debouncedSearchProduct.length > 0) {
      return true;
    }

    return false;
  };

  handleUploadSuccess = id => {
    const { fetchPromo } = this.props;
    this.setState(prevState => ({
      ...prevState,
      showImageModal: false,
    }));
    setTimeout(() => {
      fetchPromo(id);
    }, 2000);
  };

  handleNotify = id => {
    this.props
      .notifyPromo(id)
      .then(() => {
        message.success('Notified all contractors');
      })
      .catch(console.error);
  };

  handleEdit = id => {
    const promo = this.props.promos.find(p => p.id === id);
    this.setState(prevState => ({
      ...prevState,
      showEditModal: true,
      editPromo: promo,
    }));
  };

  handleDelete = id => {
    this.props.deletePromo(id).then(message);
  };

  toggleEditModal = () => {
    this.setState(prevState => ({
      ...prevState,
      showEditModal: !this.state.showEditModal,
    }));
  };

  onEditSubmit = e => {
    e.preventDefault();

    // // now = start of today
    //     const now = new Date().setHours(0, 0, 0, 0) / 1000;
    //
    //     const isOutDatePromo = row.end_date !== 0 && now > row.end_date;
    //
    //     if (isOutDatePromo && (highlightedItems || []).indexOf(row.id) >= 0) {
    //       handleOnChangeHightlight(row, { target: { checked: false } });
    //     }

    const { validateFields } = this.editForm;
    const { patchPromo } = this.props;

    validateFields((err, values) => {
      if (!err) {
        const { date_range } = values;
        let data = {};

        if (Array.isArray(date_range)) {
          let startDate = date_range[0].toDate();
          let endDate = date_range[1].toDate();

          data = {
            ...values,
            id: this.state.editPromo.id,
            start_date: startDate.toISOString(),
            end_date: endDate.toISOString(),
          };
        } else {
          data = {
            ...values,
            id: this.state.editPromo.id,
          };
        }

        delete data.date_range;

        patchPromo(data)
          .then(() => {
            this.toggleEditModal();
            if (!data.end_date) {
              return;
            }
            const endDate = new Date(data.end_date).getTime() / 1000;
            const today = new Date().setHours(0, 0, 0, 0) / 1000;
            console.log(today <= endDate);
            const highlightedList = this.state.highlightedItems;
            if (highlightedList.indexOf(data.id) >= 0 && today > endDate) {
              this.setState({
                highlightedItems: highlightedList.filter(item => item !== data.id),
              });
            }
          })
          .then(() => {
            message.success('Update successful', 1);
          })
          .catch(console.error);
      } else {
        console.error(err);
      }
    });
  };

  handleUploadOpen = id => {
    const promo = this.props.promos.find(p => p.id === id);
    this.setState(prevState => ({
      ...prevState,
      showImageModal: true,
      editPromo: promo,
    }));
  };

  toggleImageModal = () => {
    this.setState(prevState => ({
      ...prevState,
      showImageModal: !this.state.showImageModal,
    }));
  };

  renderFilterPromos = () => {
    return (
      <Card title="Filter Products">
        {PRODUCT_TYPES.map(v => (
          <Checkbox
            key={v.id}
            checked={this.state.filter.productTypes.includes(v.id)}
            onClick={() => this.handleOnClickFilterProductTypeItem(v.id)}
          >
            {v.title}
          </Checkbox>
        ))}
        <Input
          style={{ maxWidth: 'calc(200px + 4rem)', marginBottom: '0.5rem' }}
          onChange={this.onChangeSearchProductInput}
          placeholder="Search"
        />
        <Button type="primary" onClick={this.handleOnClickApplyFilter} style={{ marginLeft: '1rem' }}>
          Apply
        </Button>
        <Button style={{ marginLeft: '1rem' }} onClick={this.handleOnClickClearFilter}>
          Clear
        </Button>
      </Card>
    );
  };

  render = () => {
    const { loading, promos, products, deletePromoduct, fetchPromo, token } = this.props;
    return (
      <Container type="2x3">
        <Title title="Promotions" button={true} onClick={this.toggleCreateModal} />
        <div className={styles.Main}>
          <div>
            <div className={styles.AffixContent}>
              <Button type="primary" onClick={this.handleAddProducts}>
                Add Products to Promotion / News
              </Button>
              <Select
                defaultValue="all"
                style={{ marginLeft: '1rem', width: '170px' }}
                onChange={this.handleChangeSelectType}
              >
                <Select.Option value="all">All</Select.Option>
                <Select.Option value="promotion">Promotions</Select.Option>
                <Select.Option value="news">News</Select.Option>
              </Select>
            </div>
            <div className={styles.AffixContent}>
              {this.renderFilterPromos()}
              {this.renderEditHighlightPromos()}
            </div>
          </div>
          <PromosTable
            deletePromoduct={deletePromoduct}
            fetchPromo={fetchPromo}
            promos={promos}
            promoType={this.state.listType}
            loading={loading}
            products={products}
            searchProductKeyword={this.state.debouncedSearchProduct}
            highlightedItems={this.state.highlightedItems}
            onChangeHighlightedItems={this.handleOnChangeHighlightedItems}
            handleEdit={this.handleEdit}
            handleDelete={this.handleDelete}
            handleUploadOpen={this.handleUploadOpen}
            handleNotify={this.handleNotify}
            isAbleToHideItemHasNoProduct={this.isAbleToHideItemHasNoProduct()}
          />
          <CreatePromoModal
            ref={this.saveCreateFormRef}
            visible={this.state.showCreateModal}
            onCancel={this.toggleCreateModal}
            onOk={this.onCreateSubmit}
          />
          {this.state.showEditModal && (
            <EditPromoModal
              ref={this.saveEditFormRef}
              visible={this.state.showEditModal}
              onCancel={this.toggleEditModal}
              onOk={this.onEditSubmit}
              promo={this.state.editPromo}
            />
          )}
          <PromoImageModal
            visible={this.state.showImageModal}
            onCancel={this.toggleImageModal}
            onOk={this.toggleImageModal}
            onSuccess={this.handleUploadSuccess}
            id={this.state.editPromo.id}
            token={token}
          />
          <PromoNotifModal visible={this.props.notifLoading} />
        </div>
      </Container>
    );
  };
}

const mapStateToProps = state => {
  const { product } = state;
  const { token } = state.auth;
  var products = [].concat(
    product.tiles,
    product.stone,
    product.mosaic,
    product.wood,
    product.vinyl,
    product.countertop,
  );

  const { loading, notifLoading, promos } = state.promo;

  return { loading, notifLoading, promos, products, token };
};

const mapDispatchToProps = {
  createPromo,
  patchPromo,
  fetchPromos,
  fetchPromo,
  fetchAllProducts,
  fetchProductsByTypes,
  deletePromoduct,
  deletePromo,
  notifyPromo,
  updateHighlightedPromos,
  fetchProductTypes,
};

export default connect(mapStateToProps, mapDispatchToProps)(WithError(PromoPage, axiosCms));



// WEBPACK FOOTER //
// ./src/containers/Promo/PromoPage.js